import { AddressValidationStatus } from "@omni/types/api/customer/cloud/shared/enums/addressValidationStatus.enum";
import { ConfigPaths } from "@omni/types/utils/configPaths";
import { get } from "@omni/utils/object.utils";
import { useEffect } from "react";
import { FieldPathValue, Path, useFormContext } from "react-hook-form";

import { useAddressValidationContext } from "@/components/Address/context/AddressValidation/addressValidation.context";
import { Translate } from "@/redux/modules/value/translations/translations.provider";

import { useAddressFormBlockContext } from "../addressFormBlock.context";
import { DeliveryAddressFormValues } from "../partials/deliveryAddress.schema";

const useDeliveryHook = () => {
    const { getValues, setValue, setError } =
        useFormContext<DeliveryAddressFormValues>();
    const { displayAddressFields, validate, isValidating } =
        useAddressFormBlockContext();
    const { errorFields } = useAddressValidationContext();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (errorFields.length > 0) {
            const values = getValues();

            const fieldErrors = errorFields.reduce((acc, curr) => {
                const key =
                    `delivery.${curr.key}` as ConfigPaths<DeliveryAddressFormValues>;
                if (get(values, key) === curr.value) {
                    acc.set(
                        key as Path<DeliveryAddressFormValues>,
                        () => (t: Translate) =>
                            t(`bpost.validation.invalid.field.${curr.key}`)
                    );
                }
                return acc;
            }, new Map<
                Path<DeliveryAddressFormValues>,
                () => (t: Translate) => string
            >());

            fieldErrors.forEach((value, key) => {
                setError(key, {
                    type: "validate",
                    message: value
                });
            });
        }
    }, [errorFields]);

    useEffect(() => {
        const { delivery: address } = getValues();

        validate(address, (addressLine) => {
            setValue(
                "delivery.validationStatus",
                AddressValidationStatus.Validated as FieldPathValue<
                    DeliveryAddressFormValues,
                    "delivery.validationStatus"
                >
            );
            setValue(
                "delivery.address",
                addressLine as FieldPathValue<
                    DeliveryAddressFormValues,
                    "delivery.address"
                >
            );
        });
    }, [getValues, setValue, validate]);

    useEffect(() => {
        setValue(
            "delivery.selected",
            !displayAddressFields as FieldPathValue<
                DeliveryAddressFormValues,
                "delivery.selected"
            >
        );
    }, [displayAddressFields, setValue]);

    return {
        loading: isValidating
    };
};

export { useDeliveryHook };
